import useSiteSettings from '@utils/useSiteSettings';
import useSiteMetadata from '@utils/useSiteMetadata';
import useSiteLogo from '@utils/useSiteLogo';

const allUtils = { useSiteSettings, useSiteMetadata, useSiteLogo };

export { allUtils as default, useSiteSettings, useSiteMetadata, useSiteLogo };
